export default {
  name: {
    id: 'rm_metal_magnesium_name',
    defaultMessage: 'Magnesium',
  },
  smartphoneLabel: {
    id: 'rm_metal_magnesium_smartphone_label',
    defaultMessage: 'Significant',
  },
  whatItDoesText: {
    id: 'rm_metal_magnesium_what_it_does',
    defaultMessage:
      'Magnesium alloys can make electronic devices lighter while retaining strength and durability. In some phones, cameras and laptops, they can be used for casings or structural parts with complex shapes.',
  },
  extractionText1: {
    id: 'rm_metal_magnesium_extraction_p1',
    defaultMessage:
      'Magnesium is not found as a pure metal. It is locked inside minerals such as dolomite and magnesite, or dissolved in seawater and underground brines. In the main Chinese process, the rock is heated with a silicon-iron mixture in a vacuum. The magnesium turns into a vapour, which is cooled into crystals, melted and cast into metal.',
  },
  quickFactText: {
    id: 'rm_metal_magnesium_quick_fact',
    defaultMessage:
      'Magnesium is one of the most common elements in the Earth’s crust, yet almost nine out of ten tonnes of refined magnesium come from one country.',
  },
  envSummaryText: {
    id: 'rm_metal_magnesium_env_summary',
    defaultMessage:
      'Producing magnesium requires large amounts of fuel and creates significant air pollution. The process can also release harmful gases and fine particles into the air.',
  },
  envWaterText: {
    id: 'rm_metal_magnesium_env_water_text',
    defaultMessage:
      'Magnesium slag is an industrial waste material that can release toxic pollutants into water. In some samples from China, concentrations of mercury, copper, chromium and fluoride in water leaching from the slag exceeded national groundwater limits.',
  },
  envSoilText: {
    id: 'rm_metal_magnesium_env_soil_text',
    defaultMessage:
      'Magnesium slag can also contaminate soil. Some samples contained cadmium, mercury, copper, nickel, chromium, fluoride and chloride above Chinese screening levels for agricultural land.',
  },
  envClimateText: {
    id: 'rm_metal_magnesium_env_climate_text',
    defaultMessage:
      'Producing magnesium is energy-intensive. The main production process generates around 28 kg of CO₂ equivalent per kilogram of magnesium, mainly because it requires high temperatures and large amounts of electricity. To put this into perspective, producing one tonne of magnesium uses around 1,232 kWh of electricity, roughly the amount an average household uses in several months.',
  },
  humanSummaryText: {
    id: 'rm_metal_magnesium_human_summary',
    defaultMessage:
      'Most magnesium is produced in large industrial plants rather than small informal mines, so the main human risks are linked to industrial working conditions and the energy-intensive production process.',
  },
  geoSummaryText: {
    id: 'rm_metal_magnesium_geo_summary',
    defaultMessage:
      'Magnesium is widely available in nature, but its production is highly concentrated. China supplies almost 90% of the world’s refined magnesium, while Europe relies almost entirely on imports. This means that changes in Chinese production or trade could quickly affect manufacturers around the world.',
  },
  geoDugText: {
    id: 'rm_metal_magnesium_geo_dug_text',
    defaultMessage:
      'Magnesium is not found naturally as a pure metal. It comes from minerals such as dolomite and magnesite, as well as from underground brines, lake water and seawater. Global data do not show exactly where the raw materials used for magnesium production are mined.',
  },
  geoProcessedText: {
    id: 'rm_metal_magnesium_geo_processed_text',
    defaultMessage:
      'Most magnesium metal is produced in China, where the main process heats dolomite with a silicon-iron mixture in a vacuum. In 2024, China accounted for around 91% of primary magnesium smelter production based on the country figures reported by the USGS. Brazil, Israel and Kazakhstan each accounted for about 2%, Russia and Turkey around 1.5% each, and Iran about 0.5%.',
  },
  geoLeverageText: {
    id: 'rm_metal_magnesium_geo_leverage_text',
    defaultMessage:
      'No Chinese magnesium export restriction was identified. However, non automatic export licences were recorded for Israel and Kazakhstan in 2021 and 2022, and the United States had imposed an anti dumping measure on magnesium from China.',
  },
  supplySummaryText: {
    id: 'rm_metal_magnesium_supply_summary',
    defaultMessage:
      'The world is not running out of magnesium. The real risk is that production is concentrated in a small number of large plants and requires a lot of energy. If these plants lose access to electricity or coal, supply can fall quickly. Building alternative production capacity takes time.',
  },
  supplyReservesText: {
    id: 'rm_metal_magnesium_supply_reserves_text',
    defaultMessage:
      'Magnesium is available in many minerals, underground salt water and seawater, so geological resources are considered abundant.',
  },
  supplyDemandText: {
    id: 'rm_metal_magnesium_supply_demand_text',
    defaultMessage:
      'Demand is expected to grow as magnesium is used in aluminium alloys, lightweight products and batteries. In France, magnesium demand from the digital sector is projected to rise by 31% between 2020 and 2030. Globally, magnesium demand for clean-energy technologies is projected to more than triple by 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_magnesium_recycling_summary',
    defaultMessage:
      'Magnesium can be recycled, but most recycling happens inside factories. Clean production leftovers are easier to collect and reuse than magnesium found in old vehicles, electronics or other products.',
  },
  recyclingInputText: {
    id: 'rm_metal_magnesium_recycling_input_text',
    defaultMessage:
      'Around 13% of the magnesium used in Europe comes from recycled material recovered from old products. However, this figure covers the whole economy, not smartphones. In electronic waste, magnesium mixed with aluminium is often lost in refining waste, while separate magnesium parts are rarely collected for recycling.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_magnesium_recycling_outlook_text',
    defaultMessage:
      'Magnesium can be recycled if parts and alloys are properly collected and separated. However, no industrial recycling system for magnesium from discarded electronic devices was identified, and no future recycling rate is available. Progress will depend on better collection, sorting and demand for recovered magnesium.',
  },
  footnote1Text1: {
    id: 'rm_metal_magnesium_footnote_1_p1',
    defaultMessage:
      'Shares calculated from the country production figures reported by the USGS 2025. The USGS world total is rounded to 1,000 kt. For co-product metals, the data refer to production at the refining stage. For magnesium, “Top Mining Countries” should be understood as “Top Smelting Countries”, because magnesium is recovered as a by-product of zinc smelting.',
  },
  mine0Region: {
    id: 'rm_metal_magnesium_mine0_region',
    defaultMessage: 'Fugu region',
  },
  mine1Region: {
    id: 'rm_metal_magnesium_mine1_region',
    defaultMessage: 'Nanjing Yunhai & Shanxi Wenxi Yinguang',
  },
  mine2Region: {
    id: 'rm_metal_magnesium_mine2_region',
    defaultMessage: 'Dead Sea Magnesium',
  },
} as const
